import React from 'react';
import VideoJsSimpleFunc from './VideoJsSimpleFunc';
import './index.css';
import './WowzaPlayer.css';

import SnackBar from '../../UI/snackbar/SnackBar';

const WowzaVideoJsPlayer = (props) => (
  <div className='videoWrapper'>
    <SnackBar
      open={true}
      liveStarted={props.liveStarted}
      element={'video'}
      position={{ vertical: 'top', horizontal: 'left' }}
      preview={props.preview}
    />
    <div
      id='playerElement'
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
      }}
    >
      <VideoJsSimpleFunc src={props.sourceURL} qnaMode={props.qnaMode} />
    </div>
  </div>
);

export default React.memo(WowzaVideoJsPlayer);
